import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'homey-h3',
  imports: [],
  templateUrl: './homey-h3.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeyH3Component {

}
